import React from 'react';

import {
    MusicalNoteIcon,
    InformationCircleIcon
} from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import {Button} from 'player-components';

const NotFound = () => {

    return <div className="flex flex-1 flex-col space-y-3 justify-start px-6 py-5 items-center text-center mt-8 dark:text-secondary-300">
        <InformationCircleIcon className="w-20 h-20 "/>
        
            <h2 className="mt-2 text-sm font-medium">Oops, page not found!</h2>
            <Link to="/library">
                <Button>
                    <MusicalNoteIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
                    Go to song library
                </Button>
            </Link>
        
    </div>
}

export default NotFound;